<template>
    <vue-card>
        <header slot="header">{{controller.alias}}</header>

        <form>
            <div class="form-row">
                <div class="form-group col-md-6 col-lg-9">
                    <input type="number" class="form-control" v-model="controller.setpoint" />
                </div>
                <div class="form-group col-md-6 col-lg-3">
                    <button
                        class="btn btn-primary w-100"
                        @click="setSetpoint(controller.name, controller.setpoint)"
                    >Save</button>
                </div>
            </div>
        </form>
        <footer slot="footer" class="small">
            {{$t('lastupdate')}}: {{ timestamp }}
            <pre>
                    <p v-for="(item, name) in controller" :key="name">{{ name }}: {{item}}</p>
                </pre>
        </footer>
    </vue-card>
</template>

<style scoped>
.danger {
    border: 1px solid red;
}
</style>

<script>
import axios from "axios";
import moment from "moment";

export default {
    props: ["controller", "reading"],
    data() {
        return {
            quantity: 0,
        };
    },
    computed: {
        timestamp: function () {
            return moment(this.controller.timestamp).format(
                "dddd DD.MM.YYYY HH:mm"
            );
        },
    },

    created() {
        //const app = this;
        //if (app.controller.sensor) {
        //app.getSensorData(app.controller.sensor);
        //}
    },
    methods: {
        setSetpoint(controllerName, newSetPoint) {
            var date = {
                name: controllerName,
                setpoint: newSetPoint,
            };
            this.$emit("setSetpoint", date);
        },

        getSensorData() {
            const app = this;
            axios
                .get("/" + app.controller.sensor)
                .then((res) => {
                    app.reading = res.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>